import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService, ModalSize } from '@cv-invision/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NexsysMonitorService } from '../../../service/nexsys-monitor.service';
import { ORIGIN, URLS } from '../../model/nexsys-monitor.constant';
import { RetryNexsysEventComponent } from '../retry-nexsys-event/retry-nexsys-event.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'cv-invision-custom-action-grid-cell',
	templateUrl: './custom-action-grid-cell.component.html',
	styleUrls: ['./custom-action-grid-cell.component.scss']
})
export class CustomActionRetryCellComponent implements ICellRendererAngularComp, OnDestroy {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	public cellValue: any;
	isNexsys: boolean;
	canNotRetry: boolean;
	origin: string;
	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private modalService: ModalService,
		private nexsysMonitorService: NexsysMonitorService,
		private router: Router
	) {}

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;

		if (this.router.url.includes(URLS.NEXSYS)) {
			this.origin = ORIGIN.Nexsys;
			if (this.cellValue.action.includes('CALLBACK_')) {
				this.canNotRetry = true;
			}
		} else if (this.router.url.includes(URLS.VALUTRUST)) {
			this.origin = ORIGIN.Valutrust;
			if (this.cellValue.action.includes('CALLBACK_')) {
				this.canNotRetry = true;
			}
		}  else if (this.router.url.includes(URLS.XPANSE)) {
			this.origin = ORIGIN.Xpanse;
		} else if (this.router.url.includes(URLS.ORDER_EXTERNAL)) {
			this.origin = ORIGIN.OrderExternal;
			if (!this.cellValue.action.includes('CALLBACK_')) {
				this.canNotRetry = true;
			}
		} else if (this.router.url.includes(URLS.FNC)) {
			this.origin = ORIGIN.FNC;
			this.canNotRetry = true;
		} else if (this.router.url.includes(URLS.EVO)) {
			this.origin = ORIGIN.EVO;
			if (this.cellValue.action.includes('CALLBACK_')) {
				this.canNotRetry = true;
			}
		} else if (this.router.url.includes(URLS.VALUE_LINK)) {
			this.origin = ORIGIN.ValueLink;
			if (this.cellValue.action.includes('CALLBACK_')) {
				this.canNotRetry = true;
			}
		} else if (this.router.url.includes(URLS.CONNEXIONS)) {
			this.origin = ORIGIN.Connexions;
			if (this.cellValue.action.includes('CALLBACK_')) {
				this.canNotRetry = true;
			}
		} else if (this.router.url.includes(URLS.LENDINGQB)) {
			this.origin = ORIGIN.Lendingqb;
			if (this.cellValue.action.includes('CALLBACK_')) {
				this.canNotRetry = true;
			}
		}
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}

	/**
	 * retry call
	 */
	onRetryCall(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: RetryNexsysEventComponent,
				data: {...this.cellValue, source: this.origin},
				modalConfiguration: {
					title: `${this.origin} Retry Event`,
					modalSize: ModalSize.LG
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.success) {
					this.nexsysMonitorService.reloadList({ reload: true });
				} else {
					// it failed :(
				}
			});
	}

	/**
	 * On component destroy
	 */
	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
